import { IStorageController } from "./istorage-controller";
import { IReactConfiguration, IDictionary, ITemplate } from "../../../typings";

export default class SessionStorageController implements IStorageController {
  SESSION_STORAGE_OUTPUT_TEMPLATE: string = "label-uploader-design";
  SESSION_STORAGE_UNIT_SYSTEM: string = "label-uploader-unit-system";
  private SESSION_STORAGE_UPDATED: string = "label-uploader-updated";
  private STORAGE_DECIMAL: "," | ".";

  private conf: IReactConfiguration;
  private template?: ITemplate;
  private timeout: number;
  private output: ITemplate;
  private updated: boolean;

  constructor(conf: IReactConfiguration) {
    this.conf = conf;
    this.saveOutputTemplateAsync = this.saveOutputTemplateAsync.bind(this);
  }

  getTemplate(): ITemplate {
    if (this.hasTemplate() === true) {
      return this.template;
    }
    return null;
  }

  saveTemplate(template: ITemplate): void {
    this.template = template;
  }

  hasTemplate(): boolean {
    return typeof this.template === "object";
  }

  getOutputTemplate(): ITemplate {
    if (this.hasOutputTemplate() === true) {
      if (typeof this.timeout === "number") {
        return this.output;
      }
      return JSON.parse(
        sessionStorage.getItem(
          this.conf.sessionStorage + this.SESSION_STORAGE_OUTPUT_TEMPLATE,
        ),
      );
    }
    return null;
  }

  saveOutputTemplate(output: ITemplate): void {
    this.output = output;
    if (typeof this.timeout === "number") {
      return;
    }
    this.timeout = setTimeout(this.saveOutputTemplateAsync, 100) as any;
  }

  saveOutputTemplateAsync(): void {
    const output: ITemplate = JSON.parse(JSON.stringify(this.output));
    delete output.uploader;
    Object.keys(output.values).filter((key: string) => {
      if (typeof output.values[key][0] !== "string") {
        return true;
      }

      return output.values[key][0].slice(0, 5) !== "data:";
    });
    sessionStorage.setItem(
      this.conf.sessionStorage + this.SESSION_STORAGE_OUTPUT_TEMPLATE,
      JSON.stringify(output),
    );
    delete this.timeout;
  }

  hasOutputTemplate(): boolean {
    if (typeof this.timeout === "number") {
      return true;
    }
    const text: string = sessionStorage.getItem(
      this.conf.sessionStorage + this.SESSION_STORAGE_OUTPUT_TEMPLATE,
    );
    if (text) {
      if (text !== null && text !== "null" && text !== "") {
        return true;
      }
    }
    return false;
  }

  getUpdated(): boolean {
    if (typeof this.updated === "undefined") {
      const updated: string = window.sessionStorage.getItem(
        this.conf.sessionStorage + this.SESSION_STORAGE_UPDATED,
      );
      if (this.updated === null) {
        this.updated = false;
      }
      if (typeof this.updated === "string") {
        this.updated = updated === "1";
      }
    }

    return this.updated;
  }

  setUpdated(updated: boolean): void {
    if (this.updated === updated) {
      return;
    }

    this.updated = updated;
    window.sessionStorage.setItem(
      this.conf.sessionStorage + this.SESSION_STORAGE_UPDATED,
      updated ? "1" : "0",
    );
  }

  clearCache(): void {
    if (typeof this.timeout === "number") {
      clearTimeout(this.timeout);
    }

    delete this.template;
    window.sessionStorage.removeItem(
      this.conf.sessionStorage + this.SESSION_STORAGE_OUTPUT_TEMPLATE,
    );
    window.sessionStorage.removeItem(
      this.conf.sessionStorage + this.SESSION_STORAGE_UNIT_SYSTEM,
    );
    window.sessionStorage.removeItem(
      this.conf.sessionStorage + this.SESSION_STORAGE_UPDATED,
    );
  }
}
